<svelte:options customElement={{ tag: 's-anchor' }} />

<script lang="ts">
    import { sanchor, spath } from 'hydria/svelte_helpers'

    let { href }: { href: string } = $props()
</script>

<a use:sanchor href={spath(href)}><slot /></a>
